<template>
  <v-menu
    v-bind="$attrs"
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="localDateRange"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateRangeSorted.join('~')"
        v-on="on"
        v-bind="$attrs"
        dense
        readonly
      ></v-text-field>
    </template>
    <v-date-picker color="amber darken-1" locale="vi" range v-model="localDateRange" show-current>
      <!-- <v-btn text color="primary" @click="$refs.menu.save([])">Xóa </v-btn> -->
      <v-btn text color="primary" @click="clearDateRange">Hủy</v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="saveDateRange">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  inheritAttrs: true,
  props: {
    dateRange: {
      type: Array
      // default() {
      //   return [
      //     new Date().toISOString().substr(0, 10),
      //     new Date().toISOString().substr(0, 10),
      //   ]
      // },
    }
  },
  data: () => ({
    localDateRange: [],
    menu: false
  }),
  created() {
    this.localDateRange = this.dateRange
  },
  computed: {
    dateRangeSorted() {
      let dateRangeFormated = this.localDateRange
        .map(item => moment(item).format('DD/MM/YYYY'))
        .sort((a, b) => moment(a).diff(moment(b), 'day'))
      if (dateRangeFormated.length > 1) {
        dateRangeFormated = dateRangeFormated.sort((a, b) => {
          let firstDate = moment(a, 'DD/MM/YYYY')
          let secondDate = moment(b, 'DD/MM/YYYY')
          return firstDate.diff(secondDate, 'day')
        })
      }

      return dateRangeFormated
    }
  },
  // watch: {
  //   dateRangeSorted: {
  //     handler(val) {
  //       this.$emit('update:date-range', val)
  //     }
  //   }
  // },
  methods: {
    clearDateRange() {
      this.localDateRange = []
      this.$refs.menu.save([])
      this.$emit('update:date-range', [])
    },
    saveDateRange() {
      this.$refs.menu.save(this.localDateRange)
      this.$emit(
        'update:date-range',
        this.localDateRange.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      )
    }
  }
}
</script>
